<script>
  import Navbar from "../components/Navbar.svelte";

  export let theme;
  export let toggleTheme;
</script>

<div class="flex flex-col min-h-screen">
  <Navbar bind:theme on:toggleTheme={toggleTheme} />
  <slot />
</div>
